export default __webpack_public_path__ + "static/media/button_placement__start.99429b15.png";